import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import './styles.css';
// 原型 v0.22 的样式，作用域限定在 `.pv22` 子树内（C-159 A.1）。
import './prototype-v022.css';

const container = document.getElementById('root');
if (container === null) throw new Error('index.html 里少了 #root');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
